<template>
  <div class="itemsPerTableContainer sm:mb-0 mb-2">
    Show
    <select
      class="limitOptionDropdown"
      v-model="currentLimitSet"
      @change="onLimitChange"
    >
      <option
        v-for="(option, index) of pageLimitOptions"
        :key="index"
        :value="option"
      >
        {{ option }}
      </option>
    </select>
    entries
  </div>
</template>

<script>
import {getTableLimit, setTableLimit} from '@/api/tableItemLimit'

export default {
  name: 'ItemsPerTableDropdown',
  props: ['tableName'],
  data () {
    return {
      defaultLimit: 5,
      pageLimitOptions: [5, 10, 20, 50, 100],
      currentLimitSet: null,
      customerId: localStorage.getItem('customer_id'),
      userId: JSON.parse(localStorage.getItem('userInfo')).id
    }
  },
  created () {
    this.getTableListLimit()
  },
  methods: {
    onLimitChange () {
      this.setTableListLimit()
    },
    async getTableListLimit () {
      try {
        const payload = {
          platform_customer_id: this.customerId,
          user_id: this.userId,
          client_user_id: null,
          portal_type: 'ADMIN',
          table_name: this.tableName
        }

        const response = await getTableLimit(payload)
        if (response.status === 200) {
          this.currentLimitSet = response.data.data.table_setting.pagination_per_page || this.defaultLimit
          this.$emit('change', this.currentLimitSet)
        }

      } catch (e) {
        console.log(e)
      }
    },
    async setTableListLimit () {
      try {
        const payload = {
          platform_customer_id: this.customerId,
          user_id: this.userId,
          client_user_id: null,
          portal_type: 'ADMIN',
          table_name: this.tableName,
          pagination_per_page: this.currentLimitSet
        }

        const response = await setTableLimit(payload)
        if (response.status === 201) {
          this.$emit('change', this.currentLimitSet)
        }

      } catch (e) {
        console.log(e)
      }
    }
  }
}
</script>

<style>
.itemsPerTableContainer {
  display: flex;
}

.limitOptionDropdown {
  margin: 0 5px;
}
</style>
